<!--    個人資料-->
<template>
  <div>
    <vs-row vs-type="flex" vs-align="center">
      <vs-col vs-w="6">
        <span :class="isMobile() ? 'titleMob' : 'title'">{{
          $t("message.profile")
        }}</span>
      </vs-col>
      <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end"> </vs-col>
    </vs-row>

    <vs-row v-if="isMobile()" class="profile" vs-type="flex">
      <vs-col vs-w="12" class="textAlignCenter">
        <vs-avatar
          size="200px"
          :src="profilePic"
          @click="edit ? $refs.file.click() : ''"
        />
        <input
          @change="uploadProfilePic($event)"
          id="file1"
          ref="file"
          type="file"
          name="file"
          style="display: none;"
        />
        <vs-button
          v-if="!edit"
          radius
          color="rgb(37, 105, 193)"
          size="small"
          class="profile-edit-mob"
          @click="edit = true"
          >Edit</vs-button
        >
      </vs-col>
      <vs-col vs-w="12">
        <div class="profile-title-mob">
          <p>{{ $t("message.username") }} : {{ currentUser.username }}</p>
          <p v-if="currentUser.customer">
            {{ $t("message.customerCode") }} : {{ currentUser.customer.code }}
          </p>
          <p style="font-size: 15px" v-if="currentUser.agentNumber">
            {{ $t("message.agentNo") }} : {{ currentUser.agentNumber }}
          </p>
        </div>
        <div class="profile-body-mob m-t-1">
          <p>{{ $t("message.name") }} : {{ currentUser.name }}</p>
          <p v-if="currentUser.customer">
            {{ $t("message.gender") }} :
            {{ $t(`message.${currentUser.customer.gender}`) }}
          </p>
          <p v-if="currentUser.customer">
            {{ $t("message.dateOfBirth") }} :
            {{ currentUser.customer.dateOfBirth | dateFormat }}
          </p>
          <p v-if="!edit">
            {{ $t("message.phone") }} : {{ currentUser.phone }}
          </p>
          <div v-else class="edit-input-mob">
            <span>{{ $t("message.phone") }} : </span>
            <vs-input
              style="display: inline-block;width: 300px"
              v-model="phone"
            ></vs-input>
          </div>
          <p v-if="!edit">
            {{ $t("message.email") }} : {{ currentUser.email }}
          </p>
          <div v-else class="edit-input-mob">
            <span>{{ $t("message.email") }} : </span>
            <vs-input
              style="display: inline-block;width: 300px"
              v-model="email"
            ></vs-input>
          </div>
        </div>
        <p v-if="currentUser.customer">
          {{ $t("message.residentialAddress") }} :
          {{ currentUser.customer.residenceAddress }}
        </p>
        <p v-if="currentUser.customer">
          {{ $t("message.corrAddress") }} :
          {{ currentUser.customer.correspondenceAddress }}
        </p>
      </vs-col>
    </vs-row>
    <vs-row v-else class="profile" vs-type="flex">
      <vs-col vs-w="2" vs-sm="0"></vs-col>
      <vs-col vs-w="5" vs-sm="7">
        <div class="profile-title">
          <p>{{ $t("message.username") }} : {{ currentUser.username }}</p>
          <p v-if="currentUser.customer">
            {{ $t("message.customerCode") }} : {{ currentUser.customer.code }}
          </p>
          <p style="font-size: 15px" v-if="currentUser.agentNumber">
            {{ $t("message.agentNo") }} : {{ currentUser.agentNumber }}
          </p>
        </div>
        <div class="profile-body">
          <p>{{ $t("message.name") }} : {{ currentUser.name }}</p>
          <p v-if="currentUser.customer">
            {{ $t("message.gender") }} :
            {{ $t(`message.${currentUser.customer.gender}`) }}
          </p>
          <p v-if="currentUser.customer">
            {{ $t("message.dateOfBirth") }} :
            {{ currentUser.customer.dateOfBirth | dateFormat }}
          </p>
          <p v-if="!edit">
            {{ $t("message.phone") }} : {{ currentUser.phone }}
          </p>
          <div v-else class="edit-input">
            <span>{{ $t("message.phone") }} : </span>
            <vs-input
              style="display: inline-block;width: 300px"
              v-model="phone"
            ></vs-input>
          </div>
          <p v-if="!edit">
            {{ $t("message.email") }} : {{ currentUser.email }}
          </p>
          <div v-else class="edit-input">
            <span>{{ $t("message.email") }} : </span>
            <vs-input
              style="display: inline-block;width: 300px"
              v-model="email"
            ></vs-input>
          </div>
          <p v-if="currentUser.customer">
            {{ $t("message.residentialAddress") }} :
            {{ currentUser.customer.residenceAddress }}
          </p>
          <p v-if="currentUser.customer">
            {{ $t("message.corrAddress") }} :
            {{ currentUser.customer.correspondenceAddress }}
          </p>
        </div>
      </vs-col>
      <vs-col vs-w="5" vs-sm="5">
        <vs-avatar
          size="250px"
          :src="profilePic"
          @click="edit ? $refs.file.click() : ''"
        />
        <input
          @change="uploadProfilePic($event)"
          id="file"
          ref="file"
          type="file"
          name="file"
          style="display: none;"
        />
        <vs-button
          v-if="!edit"
          radius
          color="rgb(37, 105, 193)"
          size="small"
          class="edit"
          @click="edit = true"
          >Edit</vs-button
        >
      </vs-col>
    </vs-row>
    <vs-row v-if="edit">
      <vs-col vs-w="10" vs-type="flex" vs-justify="flex-end">
        <vs-button
          color="rgb(37, 105, 193)"
          size="small"
          @click="onSubmit()"
          style="margin-right: 10px;"
          >{{ $t("message.confirm") }}</vs-button
        >
        <vs-button
          color="danger"
          type="border"
          size="small"
          @click="onCancel()"
          >{{ $t("message.cancel") }}</vs-button
        >
      </vs-col>
    </vs-row>

    <!-- Password Update Section -->
    <vs-row vs-type="flex" vs-align="center" style="margin-top: 40px">
      <vs-col vs-w="12">
        <vs-divider></vs-divider>
        <span :class="isMobile() ? 'titleMob' : 'title'">{{
          $t("message.changePassword")
        }}</span>
      </vs-col>
    </vs-row>

    <vs-row class="profile" vs-type="flex" style="margin-top: 20px">
      <vs-col :vs-w="isMobile() ? '12' : '2'" vs-sm="0"></vs-col>
      <vs-col :vs-w="isMobile() ? '12' : '8'" vs-sm="12">
        <div :class="isMobile() ? 'password-section-mob' : 'password-section'">
          <!-- Current Password -->
          <div class="password-field">
            <span class="password-label"
              >{{ $t("message.currentPassword") }}:</span
            >
            <div class="password-input-wrapper">
              <vs-input
                :type="showCurrentPassword ? 'text' : 'password'"
                v-model="currentPassword"
                :placeholder="$t('message.enterCurrentPassword')"
                class="password-input"
              ></vs-input>
              <div class="eye-icon-password">
                <svg
                  v-if="showCurrentPassword === false"
                  @click="showCurrentPassword = true"
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                >
                  <path
                    d="M12.01 20c-5.065 0-9.586-4.211-12.01-8.424 2.418-4.103 6.943-7.576 12.01-7.576 5.135 0 9.635 3.453 11.999 7.564-2.241 4.43-6.726 8.436-11.999 8.436zm-10.842-8.416c.843 1.331 5.018 7.416 10.842 7.416 6.305 0 10.112-6.103 10.851-7.405-.772-1.198-4.606-6.595-10.851-6.595-6.116 0-10.025 5.355-10.842 6.584zm10.832-4.584c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zm0 1c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4z"
                  />
                </svg>
                <svg
                  v-else
                  @click="showCurrentPassword = false"
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                >
                  <path
                    d="M8.137 15.147c-.71-.857-1.146-1.947-1.146-3.147 0-2.76 2.241-5 5-5 1.201 0 2.291.435 3.148 1.145l1.897-1.897c-1.441-.738-3.122-1.248-5.035-1.248-6.115 0-10.025 5.355-10.842 6.584.529.834 2.379 3.527 5.113 5.428l1.865-1.865zm6.294-6.294c-.673-.53-1.515-.853-2.44-.853-2.207 0-4 1.792-4 4 0 .923.324 1.765.854 2.439l5.586-5.586zm7.56-6.146l-19.292 19.293-.708-.707 3.548-3.548c-2.298-1.612-4.234-3.885-5.548-6.169 2.418-4.103 6.943-7.576 12.01-7.576 2.065 0 4.021.566 5.782 1.501l3.501-3.501.707.707zm-2.465 3.879l-.734.734c2.236 1.619 3.628 3.604 4.061 4.274-.739 1.303-4.546 7.406-10.852 7.406-1.425 0-2.749-.368-3.951-.938l-.748.748c1.475.742 3.057 1.19 4.699 1.19 5.274 0 9.758-4.006 11.999-8.436-1.087-1.891-2.63-3.637-4.474-4.978zm-3.535 5.414c0-.554-.113-1.082-.317-1.562l.734-.734c.361.69.583 1.464.583 2.296 0 2.759-2.24 5-5 5-.832 0-1.604-.223-2.295-.583l.734-.735c.48.204 1.007.318 1.561.318 2.208 0 4-1.792 4-4z"
                  />
                </svg>
              </div>
            </div>
          </div>

          <!-- New Password -->
          <div class="password-field">
            <span class="password-label">{{ $t("message.newPassword") }}:</span>
            <div class="password-input-wrapper">
              <vs-input
                :type="showNewPassword ? 'text' : 'password'"
                v-model="newPassword"
                :placeholder="$t('message.enterNewPassword')"
                class="password-input"
              ></vs-input>
              <div class="eye-icon-password">
                <svg
                  v-if="showNewPassword === false"
                  @click="showNewPassword = true"
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                >
                  <path
                    d="M12.01 20c-5.065 0-9.586-4.211-12.01-8.424 2.418-4.103 6.943-7.576 12.01-7.576 5.135 0 9.635 3.453 11.999 7.564-2.241 4.43-6.726 8.436-11.999 8.436zm-10.842-8.416c.843 1.331 5.018 7.416 10.842 7.416 6.305 0 10.112-6.103 10.851-7.405-.772-1.198-4.606-6.595-10.851-6.595-6.116 0-10.025 5.355-10.842 6.584zm10.832-4.584c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zm0 1c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4z"
                  />
                </svg>
                <svg
                  v-else
                  @click="showNewPassword = false"
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                >
                  <path
                    d="M8.137 15.147c-.71-.857-1.146-1.947-1.146-3.147 0-2.76 2.241-5 5-5 1.201 0 2.291.435 3.148 1.145l1.897-1.897c-1.441-.738-3.122-1.248-5.035-1.248-6.115 0-10.025 5.355-10.842 6.584.529.834 2.379 3.527 5.113 5.428l1.865-1.865zm6.294-6.294c-.673-.53-1.515-.853-2.44-.853-2.207 0-4 1.792-4 4 0 .923.324 1.765.854 2.439l5.586-5.586zm7.56-6.146l-19.292 19.293-.708-.707 3.548-3.548c-2.298-1.612-4.234-3.885-5.548-6.169 2.418-4.103 6.943-7.576 12.01-7.576 2.065 0 4.021.566 5.782 1.501l3.501-3.501.707.707zm-2.465 3.879l-.734.734c2.236 1.619 3.628 3.604 4.061 4.274-.739 1.303-4.546 7.406-10.852 7.406-1.425 0-2.749-.368-3.951-.938l-.748.748c1.475.742 3.057 1.19 4.699 1.19 5.274 0 9.758-4.006 11.999-8.436-1.087-1.891-2.63-3.637-4.474-4.978zm-3.535 5.414c0-.554-.113-1.082-.317-1.562l.734-.734c.361.69.583 1.464.583 2.296 0 2.759-2.24 5-5 5-.832 0-1.604-.223-2.295-.583l.734-.735c.48.204 1.007.318 1.561.318 2.208 0 4-1.792 4-4z"
                  />
                </svg>
              </div>
            </div>
          </div>

          <!-- Confirm New Password -->
          <div class="password-field">
            <span class="password-label"
              >{{ $t("message.confirmNewPassword") }}:</span
            >
            <div class="password-input-wrapper">
              <vs-input
                :type="showConfirmPassword ? 'text' : 'password'"
                v-model="confirmPassword"
                :placeholder="$t('message.confirmNewPasswordPlaceholder')"
                class="password-input"
              ></vs-input>
              <div class="eye-icon-password">
                <svg
                  v-if="showConfirmPassword === false"
                  @click="showConfirmPassword = true"
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                >
                  <path
                    d="M12.01 20c-5.065 0-9.586-4.211-12.01-8.424 2.418-4.103 6.943-7.576 12.01-7.576 5.135 0 9.635 3.453 11.999 7.564-2.241 4.43-6.726 8.436-11.999 8.436zm-10.842-8.416c.843 1.331 5.018 7.416 10.842 7.416 6.305 0 10.112-6.103 10.851-7.405-.772-1.198-4.606-6.595-10.851-6.595-6.116 0-10.025 5.355-10.842 6.584zm10.832-4.584c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zm0 1c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4z"
                  />
                </svg>
                <svg
                  v-else
                  @click="showConfirmPassword = false"
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                >
                  <path
                    d="M8.137 15.147c-.71-.857-1.146-1.947-1.146-3.147 0-2.76 2.241-5 5-5 1.201 0 2.291.435 3.148 1.145l1.897-1.897c-1.441-.738-3.122-1.248-5.035-1.248-6.115 0-10.025 5.355-10.842 6.584.529.834 2.379 3.527 5.113 5.428l1.865-1.865zm6.294-6.294c-.673-.53-1.515-.853-2.44-.853-2.207 0-4 1.792-4 4 0 .923.324 1.765.854 2.439l5.586-5.586zm7.56-6.146l-19.292 19.293-.708-.707 3.548-3.548c-2.298-1.612-4.234-3.885-5.548-6.169 2.418-4.103 6.943-7.576 12.01-7.576 2.065 0 4.021.566 5.782 1.501l3.501-3.501.707.707zm-2.465 3.879l-.734.734c2.236 1.619 3.628 3.604 4.061 4.274-.739 1.303-4.546 7.406-10.852 7.406-1.425 0-2.749-.368-3.951-.938l-.748.748c1.475.742 3.057 1.19 4.699 1.19 5.274 0 9.758-4.006 11.999-8.436-1.087-1.891-2.63-3.637-4.474-4.978zm-3.535 5.414c0-.554-.113-1.082-.317-1.562l.734-.734c.361.69.583 1.464.583 2.296 0 2.759-2.24 5-5 5-.832 0-1.604-.223-2.295-.583l.734-.735c.48.204 1.007.318 1.561.318 2.208 0 4-1.792 4-4z"
                  />
                </svg>
              </div>
            </div>
          </div>

          <!-- Update Password Button -->
          <div class="password-actions">
            <vs-button
              color="rgb(37, 105, 193)"
              size="small"
              @click="onPasswordUpdate()"
              :disabled="!currentPassword || !newPassword || !confirmPassword"
            >
              {{ $t("message.updatePassword") }}
            </vs-button>
            <vs-button
              color="danger"
              type="border"
              size="small"
              @click="onPasswordCancel()"
              style="margin-left: 10px;"
            >
              {{ $t("message.clear") }}
            </vs-button>
          </div>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      token: "",
      edit: false,
      phone: "",
      email: "",
      profilePic: "",
      profilePicId: "",
      error: false,
      // Password fields
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
    };
  },
  created() {
    this.token = this.$cookies.get("token");
  },
  mounted() {
    this.phone = this.$store.getters.currentUser.phone || "";
    this.email = this.$store.getters.currentUser.email || "";
    this.profilePic = this.$store.getters.currentUser.profilePic.fileUrl || "";
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  methods: {
    ...mapActions(["getUser"]),
    uploadProfilePic(e) {
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      let url =
        process.env.VUE_APP_API_BASEURL +
        "/api/attachment/upload?access_token=" +
        this.token;
      fetch(url, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.log(error);
        })
        .then((result) => {
          console.log(result);
          this.profilePic = result.responseDetail.fileUrl;
          this.profilePicId = result.responseDetail._id;
        });
    },
    onSubmit() {
      let url =
        process.env.VUE_APP_API_BASEURL +
        "/api/user/" +
        this.currentUser._id +
        "?access_token=" +
        this.token;

      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phone: this.phone,
          email: this.email,
          profilePic: this.profilePicId
            ? this.profilePicId
            : this.currentUser.profilePic,
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          this.edit = false;
          if (res.responseCode === 200) {
            this.getUser({
              token: this.token,
            });
          } else if (res.responseCode == "61006") {
            this.$vs.notify({
              title: "提示",
              text: this.$t("message.oldPwdErrorMsg"),
              icon: "clear",
              color: "danger",
              position: "top-center",
              time: 3000,
            });
          } else {
            this.$vs.notify({
              title: "提示",
              text: this.$t("message.errorMsg"),
              icon: "clear",
              color: "danger",
              position: "top-center",
              time: 3000,
            });
          }
        });
    },
    onCancel() {
      this.edit = false;
      this.phone = this.currentUser.phone;
      this.email = this.currentUser.email;
    },
    // Password update method
    onPasswordUpdate() {
      // Validate passwords match
      if (this.newPassword !== this.confirmPassword) {
        this.$vs.notify({
          title: this.$t("message.error"),
          text: this.$t("message.passwordMismatch"),
          icon: "clear",
          color: "danger",
          position: "top-center",
          time: 3000,
        });
        return;
      }

      // Validate password length (optional)
      if (this.newPassword.length < 6) {
        this.$vs.notify({
          title: this.$t("message.error"),
          text: this.$t("message.passwordLengthError"),
          icon: "clear",
          color: "danger",
          position: "top-center",
          time: 3000,
        });
        return;
      }

      // API call for password update
      let url =
        process.env.VUE_APP_API_BASEURL +
        "/api/user/change-password?access_token=" +
        this.token;

      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.responseCode === 200) {
            this.$vs.notify({
              title: this.$t("message.success"),
              text: this.$t("message.passwordUpdateSuccess"),
              icon: "check",
              color: "success",
              position: "top-center",
              time: 3000,
            });
            this.onPasswordCancel();
          } else if (res.responseCode == "61006") {
            this.$vs.notify({
              title: this.$t("message.error"),
              text: this.$t("message.currentPasswordIncorrect"),
              icon: "clear",
              color: "danger",
              position: "top-center",
              time: 3000,
            });
          } else {
            this.$vs.notify({
              title: this.$t("message.error"),
              text: res.message || this.$t("message.passwordUpdateFailed"),
              icon: "clear",
              color: "danger",
              position: "top-center",
              time: 3000,
            });
          }
        })
        .catch((error) => {
          console.error("Password update error:", error);
          this.$vs.notify({
            title: this.$t("message.error"),
            text: this.$t("message.passwordUpdateError"),
            icon: "clear",
            color: "danger",
            position: "top-center",
            time: 3000,
          });
        });
    },
    onPasswordCancel() {
      this.currentPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.showCurrentPassword = false;
      this.showNewPassword = false;
      this.showConfirmPassword = false;
    },
  },
  filters: {
    dateFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
};
</script>

<style scoped>
@import "../assets/css/profile.css";

/* Password Section Styles */
.password-section {
  padding: 20px;
  background: #f9f9f9;
  border-radius: 8px;
  margin-top: 20px;
}

.password-section-mob {
  padding: 15px;
  background: #f9f9f9;
  border-radius: 8px;
  margin-top: 20px;
}

.password-field {
  margin-bottom: 20px;
}

.password-label {
  display: inline-block;
  width: 200px;
  font-weight: 500;
  color: #333;
}

.password-input-wrapper {
  display: inline-block;
  position: relative;
  width: calc(100% - 210px);
  vertical-align: middle;
}

@media (max-width: 768px) {
  .password-label {
    display: block;
    width: 100%;
    margin-bottom: 8px;
  }

  .password-input-wrapper {
    width: 100%;
  }
}

.password-input {
  width: 100%;
}

.eye-icon-password {
  position: absolute;
  cursor: pointer;
  bottom: 5px;
  right: 10px;
  z-index: 10;
}

.eye-icon-password svg {
  transform: scale(0.8);
}

.eye-icon-password:hover {
  opacity: 0.7;
}

.password-actions {
  margin-top: 25px;
  text-align: right;
}

@media (max-width: 768px) {
  .password-actions {
    text-align: center;
  }
}
</style>
<style>
.danger .vs-input--input {
  border-color: red !important;
}
.danger .vs-input--input:focus {
  border-color: red !important;
}
</style>
